import { createLogger } from '@telia-ace/edge-log';

import { loadCSS, loadJS } from './fileUtils';

const log = createLogger('utils/loadISFiles');

const loadCss = (file, instance) => {
  const link = {};
  // Only string, interpret as file name
  if (typeof instance === 'string' && typeof file === 'string') {
    link.href = instance + file;
  } else {
    // Pick up the configured properties
    Object.assign(link, file);
    link.href = instance + file.href;
  }
  if (link.href) loadCSS(link);
};

export function loadJs(file, instance) {
  log.debug('Load Javascript file:', file);

  const script = {};
  // Only string, interpret as file name
  if (typeof instance === 'string' && typeof file === 'string') {
    script.src = instance + file;
  } else {
    // Pick up the configured properties
    Object.assign(script, file);
    script.src = instance + file.src;
  }
  return loadJS(script);
}

export function load(css, js, instance) {
  if (Array.isArray(css)) {
    css.forEach((cssFile) => loadCss(cssFile, instance));
  }

  if (Array.isArray(js)) {
    js.forEach((jsFile) => loadJs(jsFile, instance));
  }
}
